/*
 *  -----------------------------------------------------------------------
 *    <copyright file="feature-context.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React, { useState } from 'react';
import Features from '../config/features';

export const FeatureContext = React.createContext({
    features: {},
    hasFeature: (feature: string): boolean => false,
    setFeature: (feature: string, on: boolean, save: boolean) => {},
});

const getFeatures = (features: any) => {
    let localStorage: any;
    try {
        localStorage = window.localStorage;
    } catch {}

    const getValue = (name: string, defaultValue: boolean) => {
        const item = localStorage?.getItem(`feature:${name}`);
        if (item === 'false') return false;

        return item ? Boolean(item) : defaultValue;
    };

    const result: any = {};
    Object.keys(features).forEach((key: string) => {
        result[features[key].id] = getValue(features[key].id, features[key].enabled);
    });

    return result;
};

const FeatureContextProvider = ({ children }: any) => {
    const [features, setFeatures] = useState(getFeatures(Features));
    let localStorage: any = null;

    try {
        localStorage = window.localStorage;
    } catch {}

    return (
        <FeatureContext.Provider
            value={{
                setFeature: (feature: string, on: boolean, save: boolean) => {
                    setFeatures({
                        ...features,
                        [feature]: Boolean(on),
                    });

                    if (save && localStorage) localStorage.setItem(`feature:${feature}`, on.toString());
                    else if (save === false && localStorage) localStorage.removeItem(`feature:${feature}`);
                },
                hasFeature: (feature: string): boolean => Boolean(features[feature]),
                features: () => Object.keys(features).filter((f) => features[f] === true),
            }}
        >
            {children}
        </FeatureContext.Provider>
    );
};

export default FeatureContextProvider;
